export enum TradeAccountTypeEnum {
  Corrente = "Corrente",
  Poupanca = "Poupanca"
}



// WEBPACK FOOTER //
// ./src/components/common/BankInfo/TradeAccountTypeEnum.ts